import React, { Component } from "react";
import Layout from "../../hoc/layout/layout";
import BannerImg from "../../assets/images/highlight/AKA07141701_7415@3x.png";
import Highlight1 from "../../assets/images/highlight-1-new.jpg";
import Highlight2 from "../../assets/images/highlight-2-new.jpg";
import Highlight3 from "../../assets/images/highlight-3-new.jpg";
import Highlight4 from "../../assets/images/highlight-4-new.jpg";
import Highlight5 from "../../assets/images/highlight-5-new.jpg";
import Highlight6 from "../../assets/images/highlight-6-new.jpg";
import Highlight7 from "../../assets/images/highlight-7-new.jpg";
import Highlight8 from "../../assets/images/highlight-8-new.jpg";
import Highlight9 from "../../assets/images/highlight-9-new.jpg";
import Highlight10 from "../../assets/images/highlight-10-new.jpg";
import Highlight11 from "../../assets/images/highlight-11-new.jpg";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { HighlightPopup } from "../../components/highlightPopup/highlightPopup";
import { LazyLoadImage } from "react-lazy-load-image-component";
import pinwheel from "../../assets/images/pinwheel.gif";
// import ImageLoader from "react-load-image";
import $ from "jquery";

const hasWindow = typeof window !== "undefined" ? true : false;
if (hasWindow) {
  window.loader = true;
}

class Highlight extends Component {
  state = {
    userTokenMain: "",
    allhightlights: [
      {
        image: Highlight8,
        title: "The Supreme Basileus Gets Candid",
        subtitle: "Chat with the Supreme on Friday 4:00 p.m.",
        description:
          "Supreme Basileus Soror Glenda Glover shares her perspective on sisterhood, the Excellence administration and program of service, leadership, and more.",
        full_description:
          "Supreme Basileus Soror Glenda Glover shares her perspective on sisterhood, the Excellence administration and program of service, leadership, and more.",
      },
      {
        image: Highlight7,
        title: "Celebrate HBCU Excellence",
        subtitle:
          "Alpha Kappa Alpha Honors Historically Black Colleges and Universities on Wednesday at 6:30 p.m.",
        description:
          "The Excellence Administration cements its HBCU pride through the establishment of more HBCU-AKA Endowment Funds on college campuses.",
        full_description:
          "The Excellence Administration cements its HBCU pride through the establishment of more HBCU-AKA Endowment Funds on college campuses.",
      },
      // {
      //   image: Highlight9,
      //   title: "Alpha Kappa Alpha Educational Advancement Recognition",
      //   subtitle: "AKA EAF Recognizes Excellence on Tuesday at 12 p.m.",
      //   description:
      //     "AKA EAF Recognizes Endowment Program recipients during this celebration.",
      //   full_description:
      //     "AKA EAF Recognizes Endowment Program recipients during this celebration.",
      // },
      {
        image: Highlight1,
        title:
          "Actor and Host Anthony Anderson Shares How He Is Living His Best Life",
        subtitle:
          "Anthony Anderson shares his self-care journey at the Health Care Forum on Monday at 12 p.m.",
        description:
          "The acclaimed actor and game show host shares how he took charge of his life and shares his personal journey in an intimate conversation moderated by Soror Star Jones.",
        full_description:
          "The acclaimed actor and game show host shares how he took charge of his life and shares his personal journey in an intimate conversation moderated by Soror Star Jones.",
      },

      {
        image: Highlight2,
        title: "Social Justice Leader Tamika Mallory Talks Progressive Impact",
        subtitle:
          "Tamika Mallory keynotes Undergraduate Celebration on Friday at 12:15 p.m.",
        description:
          "Tamika Mallory shares her journey to becoming one of the youngest and boldest voices in social justice movement.",
        full_description:
          "Tamika Mallory shares her journey to becoming one of the youngest and boldest voices in social justice movement.",
      },
      {
        image: Highlight3,
        title: "Soror Vanessa Bell Calloway Illuminates Legacy Excellence",
        subtitle:
          "Alpha Kappa Alpha recognizes Legacy Sorors in this festive event on Wednesday at 12:30 p.m.",
        description:
          "This celebration honors the special bond shared by legacy members as embodied in sisterhood through the years.",
        full_description:
          "This celebration honors the special bond shared by legacy members as embodied in sisterhood through the years.",
      },
      {
        image: Highlight4,
        title: "Soror Phylicia Rashad Inspires with Poise and Grace",
        subtitle:
          "Soror Phylicia Rashad Discusses Twenty Pearls During Our Sisterly Relations Celebration on Thursday at 12:30 p.m.",
        description:
          "The incomparable Soror Phylicia Rashad joins the Sisterly Relations Celebration and discusses Alpha Kappa Alpha, her career and Twenty Pearls with Supreme Basileus Glenda Glover.",
        full_description:
          "The incomparable Soror Phylicia Rashad joins the Sisterly Relations Celebration and discusses Alpha Kappa Alpha, her career and Twenty Pearls with Supreme Basileus Glenda Glover.",
      },

      {
        image: Highlight5,
        title: "Excellence in Caregiving with Legendary Singer Regina Belle",
        subtitle:
          "Regina Belle shares her story as a caregiver at the Excellence in Caregiving Forum: Care for the Caregiver Bootcamp on Tuesday at 10:30 a.m.",
        description:
          "Whether you are a new caregiver for a loved one or a veteran caregiver of many years, you are not alone. Get the resources you need to prioritize caregiver wellness.",
        full_description:
          "Whether you are a new caregiver for a loved one or a veteran caregiver of many years, you are not alone. Get the resources you need to prioritize caregiver wellness.",
      },
      {
        image: Highlight6,
        title: "Sorors on Capitol Hill Discuss Getting Into Good Trouble",
        subtitle:
          "Congresswomen Soror Terri Sewell and Soror Nikema Williams Explain How to Protect the Vote on Monday at 3 p.m.",
        description:
          "Congresswomen Soror Terri Sewell (D-AL) and Soror Nikema Williams (D-GA) discuss the goof trouble necessary to protect voter rights across the country.",
        full_description:
          "Congresswomen Soror Terri Sewell (D-AL) and Soror Nikema Williams (D-GA) discuss the goof trouble necessary to protect voter rights across the country.",
      },

      {
        image: Highlight10,
        title: "Star-Studded Closing Gala",
        subtitle: "AKA Rolls Out the Pink Carpet on Friday at 7:00 p.m.",
        description:
          "Sorors will be entertained at a star-studded affair highlighting various genres of music and the arts to mark the close of the 69h Virtual Boule and 2021 Leadership Conference.",
        full_description:
          "Sorors will be entertained at a star-studded affair highlighting various genres of music and the arts to mark the close of the 69h Virtual Boule and 2021 Leadership Conference.",
      },
      {
        image: Highlight11,
        title: "After Party",
        subtitle:
          "Sorors “Set It Off” at the After Party on Friday at 9:00 p.m.",
        description:
          "Sorors will “Set It Off” with the national stroll as they stroll and dance to the sounds of DJ Strafe and DJ Vader.",
        full_description:
          "Sorors will “Set It Off” with the national stroll as they stroll and dance to the sounds of DJ Strafe and DJ Vader.",
      },
    ],
    selectedHighlight: "",
    popupToggle: false,
  };
  popupHandler = (data) => {
    this.setState({
      selectedHighlight: data,
      popupToggle: true,
    });
  };

  componentDidMount() {
    if (hasWindow) {
      $(".highlight-section .highlight-colm-box").click(function () {
        $("body").addClass("active");
      });
      $(".main-close").click(function () {
        $("body").removeClass("active");
      });
    }
    let userToken = localStorage.getItem("userToken");
    this.setState({
      userTokenMain: userToken,
    });
  }

  render() {
    return (
      <div>
        {/* <div className="loader-box"></div> */}
        <HighlightPopup
          popupHandler={() => this.setState({ popupToggle: false })}
          selectedHighlight={this.state.selectedHighlight}
          popupToggle={this.state.popupToggle}
        />
        <div className="innerpage-sec highlight-section">
          <div className="overlay">
            <img src={BannerImg} alt="" />
          </div>

          <div className="section-header">
            <div className="inner">
              <h1>HIGHLIGHTS</h1>
              <p>
                This year’s conference brings the Pink Easy to you.
                <br /> Click on any of the featured events below to learn more.
              </p>
              {/* <a
                href={`https://events.aka1908.net/21991000/${this.state.userTokenMain}?redirect=recordings`}
                className="btn btn-green more-info"
                target="_blank"
              >
                WATCH RECORDINGS
              </a> */}
            </div>
          </div>

          {/* <div className="colm-row">
            {this.state.allhightlights.length > 0
              ? this.state.allhightlights.map((data, key) => (
                  <div
                    key={key}
                    onClick={() => this.popupHandler(data)}
                    className="highlight-colm-box"
                  >
                    <div className="inner-colm">
                      <a href="#" className="read-more">
                        <figure className="custom-img-box">
                          {data.image ? (
                            <img src={data.image} alt="" />
                          ) : (
                            <img src={pinwheel} alt="" />
                          )}
                        </figure>
                      </a>
                      <div className="custom-txt-box">
                        <h4 className="title">{data.title}</h4>
                        <p className="subtitle">{data.subtitle}</p>
                        <p>{data.description}</p>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </div> */}
          <div className="colm-row"></div>
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 270: 1, 480: 2, 1190: 2, 1200: 3 }}
          >
            <Masonry gutter={15}>
              {this.state.allhightlights.length > 0
                ? this.state.allhightlights.map((data, key) => (
                  <div
                    key={key}
                    onClick={() => this.popupHandler(data)}
                    className="highlight-colm-box"
                  >
                    <div className="inner-colm">
                      <figure className="custom-img-box">
                        {data.image ? (
                          <img src={data.image} alt="" />
                        ) : (
                          <img src={pinwheel} alt="" />
                        )}
                      </figure>

                      <div className="custom-txt-box">
                        <h4 className="title">{data.title}</h4>
                        <p className="subtitle">{data.subtitle}</p>
                        <p>{data.description}</p>
                      </div>
                    </div>
                  </div>
                ))
                : null}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    );
  }
}

export default Highlight;
